import { defineStore } from 'pinia'
import releasesApi from '@/helpers/releasesApi'

const PER_PAGE = 1000

interface ArtistsStore {
  artists: Artist[] | null,
}

interface ArtistsPage {
  meta: { pagesCount: number },
  data: Artist[],
}

async function getAllPages(getPage: (page: number) => Promise<ArtistsPage>): Promise<Artist[]> {
  const firstPage = await getPage(1)
  const artists = [...firstPage.data]

  for (let page = 2; page <= firstPage.meta.pagesCount; page += 1) {
    // eslint-disable-next-line no-await-in-loop -- pages are fetched sequentially to avoid spamming the API
    const nextPage = await getPage(page)
    artists.push(...nextPage.data)
  }

  return artists
}

export const useArtistsStore = defineStore('artists', {
  state: () => ({
    artists: null,
  }) as ArtistsStore,

  getters: {
    artistsWithReleases: state => state.artists?.filter(({ releaseCount }: Artist) => releaseCount),
  },

  actions: {
    async getArtists() {
      this.artists = await getAllPages(async page => {
        const { data } = await releasesApi.get<ArtistsPage>('me/artists', {
          params: {
            perPage: PER_PAGE,
            page,
          },
        })

        return data
      })
    },
  },
})
